import { useQuery } from "react-query";
import { createApiWithPath } from "../../client";
import { FieldTypesResponseData } from "../../types/field-type";
import { queryKeys } from "../../query";

interface PaginationParams {
  page?: number;
  limit?: number;
  search?: string;
}

const fetchFieldTypes = async (
  params?: PaginationParams,
): Promise<FieldTypesResponseData> => {
  const queryParams = new URLSearchParams();
  if (params?.page !== undefined) {
    queryParams.append("page", params.page.toString());
  }
  if (params?.limit !== undefined) {
    queryParams.append("limit", params.limit.toString());
  }
  if (params?.search && params.search.trim()) {
    queryParams.append("search", params.search.trim());
  }

  const url = `/field-types${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
  const { data } = await createApiWithPath("crm").get(url);
  return data;
};

export const useFieldTypes = (params?: PaginationParams) => {
  return useQuery(queryKeys.fieldTypes(params), () => fetchFieldTypes(params));
};
